import { render } from "./NetworkServerDetails.vue?vue&type=template&id=f19d1e18&ts=true"
import script from "./NetworkServerDetails.vue?vue&type=script&lang=ts"
export * from "./NetworkServerDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__